import React from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import { useLocation } from 'react-router-dom';
import { consentPluginConfig } from './consentConfig';
import { initMatamo } from '../../containers/App/matomo';
import '../../styles/cookieconsent-style-overrides.css';

const CookieConsentComponent = () => {
  const location = useLocation();
  const locale = location?.pathname?.split('/')?.[1] || 'en';

  React.useEffect(() => {
    CookieConsent.run({
      ...consentPluginConfig,
      onModalReady: ({ modal }) => {
        const btn1 = modal.querySelector('.cm__btn--secondary[data-role="necessary"]');
        const btn2 = modal.querySelector('.cm__btn--secondary[data-role="show"]');
        const container = modal.querySelector('.cm__texts');

        if (btn1 && btn2 && container) {
          const wrapper = document.createElement('div');
          wrapper.classList.add('cm__btns__wrapper');
          wrapper.appendChild(btn1);
          wrapper.appendChild(btn2);
          container.appendChild(wrapper);
        }
      },
      onConsent: () => {
        CookieConsent.acceptedCategory('analytics');
        CookieConsent.acceptedCategory('marketing');
        if (CookieConsent.acceptedCategory('analytics')) {
          initMatamo();
        }
      },
      onChange: () => {
        CookieConsent.acceptedCategory('analytics');
        CookieConsent.acceptedCategory('marketing');
        if (CookieConsent.acceptedCategory('analytics')) {
          initMatamo();
        }
      },
    });
  }, []);

  React.useEffect(() => {
    CookieConsent.setLanguage(locale);
  }, [locale]);

  return null;
};

export default CookieConsentComponent;
